const reviewData =  [
    {
        analysis: null,
        text: "Let's review a few passages from your last session",
        showText: false,
        type: "Computer"
    },
    {
        analysis: null,
        text: "I'll read it first",
        showText: false,
        type: "Computer"
    },
    {
        analysis: null,
        text: "",
        showText: true,
        analysisIndex: 0,
        type: "Computer-Human"
    },
    {
        analysis: null,
        text: "Now let's hear what you red.",
        showText: false,
        type: "Computer"
    },
    {
        analysis: {
            RecognitionStatus: "Success",
            NBest: [
                {
                    MaskedITN: "mr mcgregor caught sight of him at the corner but peter did not care",
                    FluencyScore: 13,
                    PronScore: 16.2,
                    AccuracyScore: 13,
                    ITN: "Mr McGregor caught sight of him at the corner but Peter did not care",
                    Words: [
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "m",
                                    Offset: 1100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 1400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 1700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 2000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 2300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 2600000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "Mr",
                            ErrorType: "Mispronunciation",
                            Duration: 1700000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "mih",
                                    Offset: 1100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 1100000,
                                    Syllable: "staxr",
                                    Offset: 1700000
                                }
                            ],
                            Offset: 1100000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "m",
                                    Offset: 2900000
                                },
                                {
                                    AccuracyScore: 49,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 3200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "g",
                                    Offset: 3500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 3800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "eh",
                                    Offset: 4100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "g",
                                    Offset: 4400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 4700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 5000000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "McGregor",
                            ErrorType: "Mispronunciation",
                            Duration: 2300000,
                            Syllables: [
                                {
                                    AccuracyScore: 24,
                                    Duration: 500000,
                                    Syllable: "max",
                                    Offset: 2900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "greh",
                                    Offset: 3500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "gaxr",
                                    Offset: 4400000
                                }
                            ],
                            Offset: 2900000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 5300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ao",
                                    Offset: 5600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 5900000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "caught",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "kaot",
                                    Offset: 5300000
                                }
                            ],
                            Offset: 5300000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 6200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ay",
                                    Offset: 6500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 6800000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "sight",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "sayt",
                                    Offset: 6200000
                                }
                            ],
                            Offset: 6200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 11,
                                    Duration: 200000,
                                    Phoneme: "ah",
                                    Offset: 7100000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "v",
                                    Offset: 7400000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "of",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 26,
                                    Duration: 500000,
                                    Syllable: "ahv",
                                    Offset: 7100000
                                }
                            ],
                            Offset: 7100000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "h",
                                    Offset: 11500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 11800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "m",
                                    Offset: 12100000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "him",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "hihm",
                                    Offset: 11500000
                                }
                            ],
                            Offset: 11500000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "ae",
                                    Offset: 12400000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 12700000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "at",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 500000,
                                    Syllable: "aet",
                                    Offset: 12400000
                                }
                            ],
                            Offset: 12400000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "dh",
                                    Offset: 14300000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 14600000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "the",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 500000,
                                    Syllable: "dhax",
                                    Offset: 14300000
                                }
                            ],
                            Offset: 14300000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 55,
                                    Duration: 600000,
                                    Phoneme: "k",
                                    Offset: 14900000
                                },
                                {
                                    AccuracyScore: 36,
                                    Duration: 300000,
                                    Phoneme: "ao",
                                    Offset: 15600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 16000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 16300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 16600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 16900000
                                }
                            ],
                            AccuracyScore: 23,
                            Word: "corner",
                            ErrorType: "Mispronunciation",
                            Duration: 2200000,
                            Syllables: [
                                {
                                    AccuracyScore: 38,
                                    Duration: 1300000,
                                    Syllable: "kaor",
                                    Offset: 14900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "naxr",
                                    Offset: 16300000
                                }
                            ],
                            Offset: 14900000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "b",
                                    Offset: 17200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ah",
                                    Offset: 17500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 300000,
                                    Phoneme: "t",
                                    Offset: 17800000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "but",
                            ErrorType: "Mispronunciation",
                            Duration: 900000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 900000,
                                    Syllable: "baht",
                                    Offset: 17200000
                                }
                            ],
                            Offset: 17200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "p",
                                    Offset: 18200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 18500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 18800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 19100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 19400000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "Peter",
                            ErrorType: "Mispronunciation",
                            Duration: 1400000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "piy",
                                    Offset: 18200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "taxr",
                                    Offset: 18800000
                                }
                            ],
                            Offset: 18200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "d",
                                    Offset: 19700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 20000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "d",
                                    Offset: 20300000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "did",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "dihd",
                                    Offset: 19700000
                                }
                            ],
                            Offset: 19700000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 20600000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "aa",
                                    Offset: 20900000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 21200000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "not",
                            ErrorType: "None",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 800000,
                                    Syllable: "naat",
                                    Offset: 20600000
                                }
                            ],
                            Offset: 20600000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 21500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "eh",
                                    Offset: 21800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 22100000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "care",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "kehr",
                                    Offset: 21500000
                                }
                            ],
                            Offset: 21500000
                        }
                    ],
                    Lexical: "Mr McGregor caught sight of him at the corner but Peter did not care",
                    CompletenessScore: 29,
                    Display: "Mr McGregor caught sight of him at the corner, but Peter did not care."
                }
            ],
            Duration: 22400000,
            Offset: 200000
        },
        text: "",
        recordedUrl: "",
        showText: true,
        analysisIndex: 0,
        type: "RecordedMedia"
    },
    {
        analysis: null,
        text: "Click on the ear symbol to listen again. When you're ready, click on the reecord button and try reading the passage again",
        showText: false,
        type: "Computer"
    },
    {
        analysis: null,
        showText: true,
        text: "",
        analysisIndex: 0,
        type: "Player"
    },
    {
        analysis: null,
        text: "Great job, let's move on",
        showText: false,
        type: "Computer"
    },
    {
        analysis: null,
        text: "Let's try another one",
        showText: false,
        type: "Computer"
    },
    {
        analysis: null,
        text: "",
        showText: true,
        analysisIndex: 1,
        type: "Computer-Human"
    },
    {
        analysis: null,
        text: "Now let's hear what you red",
        showText: false,
        type: "Computer"
    },
    {
        analysis: {
            RecognitionStatus: "Success",
            NBest: [
                {
                    MaskedITN: "he went back towards the tool-shed but suddenly quite close to him he heard the noise of a hoe--scr-r-ritch scratch scratch scritch",
                    FluencyScore: 14,
                    PronScore: 17,
                    AccuracyScore: 13,
                    ITN: "He went back towards the tool-shed but suddenly quite close to him he heard the noise of a hoe--scr-r-ritch scratch scratch scritch",
                    Words: [
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "h",
                                    Offset: 500000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 800000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "He",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 500000,
                                    Syllable: "hiy",
                                    Offset: 500000
                                }
                            ],
                            Offset: 500000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "w",
                                    Offset: 1100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "eh",
                                    Offset: 1400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 1700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 2000000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "went",
                            ErrorType: "Mispronunciation",
                            Duration: 1100000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1100000,
                                    Syllable: "wehnt",
                                    Offset: 1100000
                                }
                            ],
                            Offset: 1100000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "b",
                                    Offset: 2300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ae",
                                    Offset: 2600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 2900000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "back",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "baek",
                                    Offset: 2300000
                                }
                            ],
                            Offset: 2300000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 44,
                                    Duration: 400000,
                                    Phoneme: "t",
                                    Offset: 3200000
                                },
                                {
                                    AccuracyScore: 6,
                                    Duration: 300000,
                                    Phoneme: "ao",
                                    Offset: 3700000
                                },
                                {
                                    AccuracyScore: 38,
                                    Duration: 300000,
                                    Phoneme: "r",
                                    Offset: 4100000
                                },
                                {
                                    AccuracyScore: 23,
                                    Duration: 300000,
                                    Phoneme: "d",
                                    Offset: 4500000
                                },
                                {
                                    AccuracyScore: 15,
                                    Duration: 300000,
                                    Phoneme: "z",
                                    Offset: 4900000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "towards",
                            ErrorType: "Mispronunciation",
                            Duration: 2000000,
                            Syllables: [
                                {
                                    AccuracyScore: 26,
                                    Duration: 2000000,
                                    Syllable: "taordz",
                                    Offset: 3200000
                                }
                            ],
                            Offset: 3200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "dh",
                                    Offset: 5300000
                                },
                                {
                                    AccuracyScore: 26,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 5600000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "the",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 33,
                                    Duration: 500000,
                                    Syllable: "dhax",
                                    Offset: 5300000
                                }
                            ],
                            Offset: 5300000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 5900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "uw",
                                    Offset: 6200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "l",
                                    Offset: 6500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "sh",
                                    Offset: 6800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "eh",
                                    Offset: 7100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "d",
                                    Offset: 7400000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "tool-shed",
                            ErrorType: "Mispronunciation",
                            Duration: 1700000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "tuwl",
                                    Offset: 5900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "shehd",
                                    Offset: 6800000
                                }
                            ],
                            Offset: 5900000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "b",
                                    Offset: 7700000
                                },
                                {
                                    AccuracyScore: 7,
                                    Duration: 200000,
                                    Phoneme: "ah",
                                    Offset: 8000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 8300000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "but",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 2,
                                    Duration: 800000,
                                    Syllable: "baht",
                                    Offset: 7700000
                                }
                            ],
                            Offset: 7700000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 8600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ah",
                                    Offset: 8900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "d",
                                    Offset: 9200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 9500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 9800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "l",
                                    Offset: 10100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 10400000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "suddenly",
                            ErrorType: "Mispronunciation",
                            Duration: 2000000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "sah",
                                    Offset: 8600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "daxn",
                                    Offset: 9200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "liy",
                                    Offset: 10100000
                                }
                            ],
                            Offset: 8600000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 10700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "w",
                                    Offset: 11000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ay",
                                    Offset: 11300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 11600000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "quite",
                            ErrorType: "Mispronunciation",
                            Duration: 1100000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1100000,
                                    Syllable: "kwayt",
                                    Offset: 10700000
                                }
                            ],
                            Offset: 10700000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 11900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 300000,
                                    Phoneme: "l",
                                    Offset: 12200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ow",
                                    Offset: 12600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 12900000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "close",
                            ErrorType: "Mispronunciation",
                            Duration: 1200000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1200000,
                                    Syllable: "klows",
                                    Offset: 11900000
                                }
                            ],
                            Offset: 11900000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 13200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "uh",
                                    Offset: 13500000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "to",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 20,
                                    Duration: 500000,
                                    Syllable: "tuh",
                                    Offset: 13200000
                                }
                            ],
                            Offset: 13200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 300000,
                                    Phoneme: "h",
                                    Offset: 13800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 14200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "m",
                                    Offset: 14500000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "him",
                            ErrorType: "Mispronunciation",
                            Duration: 900000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 900000,
                                    Syllable: "hihm",
                                    Offset: 13800000
                                }
                            ],
                            Offset: 13800000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "h",
                                    Offset: 14800000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 15100000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "he",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 500000,
                                    Syllable: "hiy",
                                    Offset: 14800000
                                }
                            ],
                            Offset: 14800000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "h",
                                    Offset: 15400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "er",
                                    Offset: 15700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 16000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "d",
                                    Offset: 16300000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "heard",
                            ErrorType: "Mispronunciation",
                            Duration: 1100000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1100000,
                                    Syllable: "herrd",
                                    Offset: 15400000
                                }
                            ],
                            Offset: 15400000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "dh",
                                    Offset: 16600000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 16900000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "the",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 500000,
                                    Syllable: "dhax",
                                    Offset: 16600000
                                }
                            ],
                            Offset: 16600000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 17200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "oy",
                                    Offset: 17500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "z",
                                    Offset: 17800000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "noise",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "noyz",
                                    Offset: 17200000
                                }
                            ],
                            Offset: 17200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ah",
                                    Offset: 18100000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "v",
                                    Offset: 18400000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "of",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 20,
                                    Duration: 500000,
                                    Syllable: "ahv",
                                    Offset: 18100000
                                }
                            ],
                            Offset: 18100000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 18700000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "a",
                            ErrorType: "None",
                            Duration: 200000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Syllable: "ax",
                                    Offset: 18700000
                                }
                            ],
                            Offset: 18700000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 300000,
                                    Phoneme: "h",
                                    Offset: 19000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ow",
                                    Offset: 19400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "eh",
                                    Offset: 19700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 20000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 20300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 20600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "aa",
                                    Offset: 20900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 21200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "aa",
                                    Offset: 21500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 21800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 22100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 22400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ch",
                                    Offset: 22700000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "hoe--scr-r-ritch",
                            ErrorType: "Mispronunciation",
                            Duration: 3900000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 600000,
                                    Syllable: "how",
                                    Offset: 19000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "ehs",
                                    Offset: 19700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "siy",
                                    Offset: 20300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "aar",
                                    Offset: 20900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "aar",
                                    Offset: 21500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "rihch",
                                    Offset: 22100000
                                }
                            ],
                            Offset: 19000000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 23000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 23300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 23600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ae",
                                    Offset: 23900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ch",
                                    Offset: 24200000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "scratch",
                            ErrorType: "Mispronunciation",
                            Duration: 1400000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1400000,
                                    Syllable: "skraech",
                                    Offset: 23000000
                                }
                            ],
                            Offset: 23000000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 24500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 24800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 25100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ae",
                                    Offset: 25400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ch",
                                    Offset: 25700000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "scratch",
                            ErrorType: "Mispronunciation",
                            Duration: 1400000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1400000,
                                    Syllable: "skraech",
                                    Offset: 24500000
                                }
                            ],
                            Offset: 24500000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 26000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 26300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 26600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 26900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ch",
                                    Offset: 27200000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "scritch",
                            ErrorType: "Mispronunciation",
                            Duration: 1400000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1400000,
                                    Syllable: "skrihch",
                                    Offset: 26000000
                                }
                            ],
                            Offset: 26000000
                        }
                    ],
                    Lexical: "He went back towards the tool-shed but suddenly quite close to him he heard the noise of a hoe--scr-r-ritch scratch scratch scritch",
                    CompletenessScore: 32,
                    Display: "He went back towards the Tool-shed, but suddenly quite close to him. He heard the noise of a hoe--scr-r-ritch scratch scratch scritch."
                }
            ],
            Duration: 27400000,
            Offset: 300000
        },
        text: "",
        recordedUrl: "",
        showText: true,
        analysisIndex: 1,
        type: "RecordedMedia"
    },
    {
        analysis: null,
        text: "",
        // text: "He went back towards the tool-shed, but suddenly, quite close to him, he heard the noise of a hoe--scr-r-ritch, scratch, scratch, scritch.",
        showText: true,
        analysisIndex: 1,
        type: "Player"
    },
    {
        analysis: null,
        text: "Great job, let's move on",
        showText: false,
        type: "Computer"
    },
    {
        analysis: null,
        text: "",
        showText: true,
        analysisIndex: 2,
        type: "Computer-Human"
    },
    {
        analysis: null,
        text: "Now let's hear what you red",
        showText: false,
        type: "Computer"
    },
    {
        analysis: {
            RecognitionStatus: "Success",
            NBest: [
                {
                    MaskedITN: "after a time he began to wander about going lippity--lippity--not very fast and looking all round",
                    FluencyScore: 15,
                    PronScore: 17,
                    AccuracyScore: 13,
                    ITN: "After a time he began to wander about going lippity--lippity--not very fast and looking all round",
                    Words: [
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ae",
                                    Offset: 9800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "f",
                                    Offset: 10100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 10400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 10700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 11000000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "After",
                            ErrorType: "Mispronunciation",
                            Duration: 1400000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "aef",
                                    Offset: 9800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "taxr",
                                    Offset: 10400000
                                }
                            ],
                            Offset: 9800000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 16,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 11300000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "a",
                            ErrorType: "None",
                            Duration: 200000,
                            Syllables: [
                                {
                                    AccuracyScore: 16,
                                    Duration: 200000,
                                    Syllable: "ax",
                                    Offset: 11300000
                                }
                            ],
                            Offset: 11300000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 11600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ay",
                                    Offset: 11900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "m",
                                    Offset: 12200000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "time",
                            ErrorType: "Mispronunciation",
                            Duration: 800000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "taym",
                                    Offset: 11600000
                                }
                            ],
                            Offset: 11600000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "h",
                                    Offset: 12500000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 12800000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "he",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 500000,
                                    Syllable: "hiy",
                                    Offset: 12500000
                                }
                            ],
                            Offset: 12500000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "b",
                                    Offset: 13100000
                                },
                                {
                                    AccuracyScore: 37,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 13400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "g",
                                    Offset: 13700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ae",
                                    Offset: 14000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 14300000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "began",
                            ErrorType: "Mispronunciation",
                            Duration: 1400000,
                            Syllables: [
                                {
                                    AccuracyScore: 18,
                                    Duration: 500000,
                                    Syllable: "bih",
                                    Offset: 13100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "gaen",
                                    Offset: 13700000
                                }
                            ],
                            Offset: 13100000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 14600000
                                },
                                {
                                    AccuracyScore: 8,
                                    Duration: 200000,
                                    Phoneme: "uh",
                                    Offset: 14900000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "to",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 24,
                                    Duration: 500000,
                                    Syllable: "tuh",
                                    Offset: 14600000
                                }
                            ],
                            Offset: 14600000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "w",
                                    Offset: 15200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "aa",
                                    Offset: 15500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 15800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "d",
                                    Offset: 16100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 16400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 16700000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "wander",
                            ErrorType: "Mispronunciation",
                            Duration: 1700000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "waan",
                                    Offset: 15200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "daxr",
                                    Offset: 16100000
                                }
                            ],
                            Offset: 15200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 17000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "b",
                                    Offset: 17300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "aw",
                                    Offset: 17600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 17900000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "about",
                            ErrorType: "Mispronunciation",
                            Duration: 1100000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Syllable: "ax",
                                    Offset: 17000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "bawt",
                                    Offset: 17300000
                                }
                            ],
                            Offset: 17000000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "g",
                                    Offset: 18200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ow",
                                    Offset: 18500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 18800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ng",
                                    Offset: 19100000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "going",
                            ErrorType: "Mispronunciation",
                            Duration: 1100000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "gow",
                                    Offset: 18200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "ihng",
                                    Offset: 18800000
                                }
                            ],
                            Offset: 18200000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "l",
                                    Offset: 19400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 19700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "p",
                                    Offset: 20000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 20300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 20600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 20900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "l",
                                    Offset: 21200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ih",
                                    Offset: 21500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "p",
                                    Offset: 21800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ax",
                                    Offset: 22100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 22400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 22700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 23000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "aa",
                                    Offset: 23300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 23600000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "lippity--lippity--not",
                            ErrorType: "Mispronunciation",
                            Duration: 4400000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "lih",
                                    Offset: 19400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "pax",
                                    Offset: 20000000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "tiy",
                                    Offset: 20600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "lih",
                                    Offset: 21200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "pax",
                                    Offset: 21800000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "tiy",
                                    Offset: 22400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 800000,
                                    Syllable: "naat",
                                    Offset: 23000000
                                }
                            ],
                            Offset: 19400000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "v",
                                    Offset: 23900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "eh",
                                    Offset: 24200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 24500000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "iy",
                                    Offset: 24800000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "very",
                            ErrorType: "Mispronunciation",
                            Duration: 1100000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "veh",
                                    Offset: 23900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "riy",
                                    Offset: 24500000
                                }
                            ],
                            Offset: 23900000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "f",
                                    Offset: 25100000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ae",
                                    Offset: 25400000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "s",
                                    Offset: 25700000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "t",
                                    Offset: 26000000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "fast",
                            ErrorType: "Mispronunciation",
                            Duration: 1100000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 1100000,
                                    Syllable: "faest",
                                    Offset: 25100000
                                }
                            ],
                            Offset: 25100000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 1,
                                    Duration: 600000,
                                    Phoneme: "ae",
                                    Offset: 26300000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 27000000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "and",
                            ErrorType: "None",
                            Duration: 900000,
                            Syllables: [
                                {
                                    AccuracyScore: 13,
                                    Duration: 900000,
                                    Syllable: "aen",
                                    Offset: 26300000
                                }
                            ],
                            Offset: 26300000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "l",
                                    Offset: 27300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "uh",
                                    Offset: 27600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "k",
                                    Offset: 27900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 400000,
                                    Phoneme: "ih",
                                    Offset: 28200000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "ng",
                                    Offset: 28700000
                                }
                            ],
                            AccuracyScore: 0,
                            Word: "looking",
                            ErrorType: "Mispronunciation",
                            Duration: 1600000,
                            Syllables: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 500000,
                                    Syllable: "luh",
                                    Offset: 27300000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 1000000,
                                    Syllable: "kihng",
                                    Offset: 27900000
                                }
                            ],
                            Offset: 27300000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "ao",
                                    Offset: 29000000
                                },
                                {
                                    AccuracyScore: 40,
                                    Duration: 200000,
                                    Phoneme: "l",
                                    Offset: 29300000
                                }
                            ],
                            AccuracyScore: 40,
                            Word: "all",
                            ErrorType: "None",
                            Duration: 500000,
                            Syllables: [
                                {
                                    AccuracyScore: 40,
                                    Duration: 500000,
                                    Syllable: "aol",
                                    Offset: 29000000
                                }
                            ],
                            Offset: 29000000
                        },
                        {
                            Phonemes: [
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "r",
                                    Offset: 29600000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "aw",
                                    Offset: 29900000
                                },
                                {
                                    AccuracyScore: 0,
                                    Duration: 200000,
                                    Phoneme: "n",
                                    Offset: 30200000
                                },
                                {
                                    AccuracyScore: 6,
                                    Duration: 500000,
                                    Phoneme: "d",
                                    Offset: 30500000
                                }
                            ],
                            AccuracyScore: 2,
                            Word: "round",
                            ErrorType: "Mispronunciation",
                            Duration: 1400000,
                            Syllables: [
                                {
                                    AccuracyScore: 2,
                                    Duration: 1400000,
                                    Syllable: "rawnd",
                                    Offset: 29600000
                                }
                            ],
                            Offset: 29600000
                        }
                    ],
                    Lexical: "After a time he began to wander about going lippity--lippity--not very fast and looking all round",
                    CompletenessScore: 31,
                    Display: "After a time, he began to wander about going lippity--lippity--not very fast and looking all round."
                }
            ],
            Duration: 22000000,
            Offset: 9300000
        },
        text: "",
        recordedUrl: "",
        showText: true,
        analysisIndex: 2,
        type: "RecordedMedia"
    },
    {
        analysis: null,
        text: "",
        showText: true,
        analysisIndex: 2,
        type: "Player"
    },
    {
        analysis: null,
        text: "Great job, now let's get back to the book!",
        showText: false,
        type: "Computer"
    },
]

export default reviewData;